
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93vii23gGfccMeta } from "/home/node/app/shop/pages/[...slug].vue?macro=true";
import { default as _91hash_93TZvht9Dz67Meta } from "/home/node/app/shop/pages/activate_career_registration/[hash].vue?macro=true";
import { default as _91hash_93ovpJcjmylIMeta } from "/home/node/app/shop/pages/activate_registration/[hash].vue?macro=true";
import { default as _91hash_93gsAHaqMCmAMeta } from "/home/node/app/shop/pages/admin/cms/content_preview/[hash].vue?macro=true";
import { default as indexQNoSmgA0BdMeta } from "/home/node/app/shop/pages/ajandekkartya-igenyles/index.vue?macro=true";
import { default as index4BcWeZxjTiMeta } from "/home/node/app/shop/pages/bm-payment-return/index.vue?macro=true";
import { default as _91hash_937pKYlTdTYQMeta } from "/home/node/app/shop/pages/career_password_change/[hash].vue?macro=true";
import { default as _91slug_93stvohlG6D2Meta } from "/home/node/app/shop/pages/catalog/[slug].vue?macro=true";
import { default as index1HztosNF15Meta } from "/home/node/app/shop/pages/catalog/index.vue?macro=true";
import { default as _91status_934G6nGpDLTxMeta } from "/home/node/app/shop/pages/cetelem/back/[order_ident]/[status].vue?macro=true";
import { default as index44HAM41D6AMeta } from "/home/node/app/shop/pages/cetelem/back/index.vue?macro=true";
import { default as _91id_93HSpFzXwdaaMeta } from "/home/node/app/shop/pages/content/[id].vue?macro=true";
import { default as indexB6HveBuzRQMeta } from "/home/node/app/shop/pages/csr/index.vue?macro=true";
import { default as indexi8wFU8pJ5hMeta } from "/home/node/app/shop/pages/faq/index.vue?macro=true";
import { default as indexcyhSpl56wbMeta } from "/home/node/app/shop/pages/food-delivery-map/index.vue?macro=true";
import { default as indexpOWQxvpwCzMeta } from "/home/node/app/shop/pages/forgotten-password/index.vue?macro=true";
import { default as indexxI9drhjhuDMeta } from "/home/node/app/shop/pages/index.vue?macro=true";
import { default as indexSC4GF1kSJuMeta } from "/home/node/app/shop/pages/inspirations/index.vue?macro=true";
import { default as _91applicationGuid_93UACRtUm4tqMeta } from "/home/node/app/shop/pages/karrier/ajanlatok/[applicationGuid].vue?macro=true";
import { default as _91hash_93Kvzfr3Zs15Meta } from "/home/node/app/shop/pages/karrier/allas/[slug].j-[id]/[hash].vue?macro=true";
import { default as indexb3LInLQWhPMeta } from "/home/node/app/shop/pages/karrier/allas/[slug].j-[id]/index.vue?macro=true";
import { default as index0Vc2kInqmwMeta } from "/home/node/app/shop/pages/karrier/hirek/index.vue?macro=true";
import { default as SalesforceRpLrt2nYqmMeta } from "/home/node/app/shop/pages/login/Salesforce.vue?macro=true";
import { default as index0nkIp9U28UMeta } from "/home/node/app/shop/pages/loyalty-program/faq/index.vue?macro=true";
import { default as _91slug_93mtGs7l9wl3Meta } from "/home/node/app/shop/pages/news/[type]/[slug].vue?macro=true";
import { default as index1l1eHyVrkYMeta } from "/home/node/app/shop/pages/news/index.vue?macro=true";
import { default as indexWhH8Xgxw7DMeta } from "/home/node/app/shop/pages/otp/back/index.vue?macro=true";
import { default as _91hash_93ieNASGO0x6Meta } from "/home/node/app/shop/pages/password_change/[hash].vue?macro=true";
import { default as indexdpLLODj4LOMeta } from "/home/node/app/shop/pages/payment-redirect/index.vue?macro=true";
import { default as _91slug_93P7osP2mq8YMeta } from "/home/node/app/shop/pages/petrol/[slug].vue?macro=true";
import { default as indexFEH3w2yZ6FMeta } from "/home/node/app/shop/pages/petrol/faq/index.vue?macro=true";
import { default as indexqHI4RhCB24Meta } from "/home/node/app/shop/pages/petrol/index.vue?macro=true";
import { default as indexwECjOhRjxBMeta } from "/home/node/app/shop/pages/press/index.vue?macro=true";
import { default as indexaZXwqL9skMMeta } from "/home/node/app/shop/pages/prize-game/index.vue?macro=true";
import { default as _91id_937vjlgmgNzyMeta } from "/home/node/app/shop/pages/product-list/[id].vue?macro=true";
import { default as _91id_93ltvjOSYxjZMeta } from "/home/node/app/shop/pages/product/[id].vue?macro=true";
import { default as indexN8hjkpKSOVMeta } from "/home/node/app/shop/pages/shop/basket/index.vue?macro=true";
import { default as _91orderIdent_93zBL4WFDr1UMeta } from "/home/node/app/shop/pages/shop/checkout-success/[orderIdent].vue?macro=true";
import { default as _91type_932cM847pHysMeta } from "/home/node/app/shop/pages/shop/checkout/[type].vue?macro=true";
import { default as index5l4sB6dbXdMeta } from "/home/node/app/shop/pages/shop/compare/index.vue?macro=true";
import { default as indexKnSZWeQjOIMeta } from "/home/node/app/shop/pages/shop/index.vue?macro=true";
import { default as _91list_name_93uif8j5KMxUMeta } from "/home/node/app/shop/pages/shop/list/[list_name].vue?macro=true";
import { default as _91list_name_93xPFJgISEL6Meta } from "/home/node/app/shop/pages/shop/loyalty-offers/[list_name].vue?macro=true";
import { default as indexlQOhyuvAS5Meta } from "/home/node/app/shop/pages/shop/profile/billing-addresses/index.vue?macro=true";
import { default as index7ylE7OhQj1Meta } from "/home/node/app/shop/pages/shop/profile/data/index.vue?macro=true";
import { default as index4NLRw7nPzCMeta } from "/home/node/app/shop/pages/shop/profile/delivery-addresses/index.vue?macro=true";
import { default as couponsJTHtAW6WxaMeta } from "/home/node/app/shop/pages/shop/profile/loyalty-card/coupons.vue?macro=true";
import { default as indexDH7sHo27W4Meta } from "/home/node/app/shop/pages/shop/profile/loyalty-card/index.vue?macro=true";
import { default as partner_45programRfdRBFCgxuMeta } from "/home/node/app/shop/pages/shop/profile/loyalty-card/partner-program.vue?macro=true";
import { default as _91id_93RZPRUIfXksMeta } from "/home/node/app/shop/pages/shop/profile/loyalty-card/stickers/[id].vue?macro=true";
import { default as indexfFtOpww9USMeta } from "/home/node/app/shop/pages/shop/profile/loyalty-card/stickers/index.vue?macro=true";
import { default as transactionsxSRjEBp4kYMeta } from "/home/node/app/shop/pages/shop/profile/loyalty-card/transactions.vue?macro=true";
import { default as indexeVkScb6RCWMeta } from "/home/node/app/shop/pages/shop/profile/loyalty-program/index.vue?macro=true";
import { default as index7ysS7fJFJeMeta } from "/home/node/app/shop/pages/shop/profile/mailing-addresses/index.vue?macro=true";
import { default as indexbXQEJQhltJMeta } from "/home/node/app/shop/pages/shop/profile/manage/index.vue?macro=true";
import { default as indexujAj74ulLWMeta } from "/home/node/app/shop/pages/shop/profile/order-again/index.vue?macro=true";
import { default as indexlcrmltyF7XMeta } from "/home/node/app/shop/pages/shop/profile/orders/index.vue?macro=true";
import { default as indexGK17q6kRkeMeta } from "/home/node/app/shop/pages/shop/profile/saved-baskets/index.vue?macro=true";
import { default as indexmepq9GzrLCMeta } from "/home/node/app/shop/pages/simple/back/index.vue?macro=true";
import { default as _91slug_934MzHKpJRObMeta } from "/home/node/app/shop/pages/stores/[slug].vue?macro=true";
import { default as indexnOnj926mtMMeta } from "/home/node/app/shop/pages/stores/index.vue?macro=true";
import { default as indexGEiqJWkjGCMeta } from "/home/node/app/shop/pages/test/recon/index.vue?macro=true";
import { default as indexdlXLpZQ5qSMeta } from "/home/node/app/shop/pages/unsubscribe/index.vue?macro=true";
import { default as _91hash_93xkuTUSaS2RMeta } from "/home/node/app/shop/pages/user_email_update/[hash].vue?macro=true";
import { default as component_45stubES7zRCavDcMeta } from "/home/node/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubES7zRCavDc } from "/home/node/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "slug___hu",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93vii23gGfccMeta || {},
    component: () => import("/home/node/app/shop/pages/[...slug].vue")
  },
  {
    name: "slug___en",
    path: "/en/:slug(.*)*",
    meta: _91_46_46_46slug_93vii23gGfccMeta || {},
    component: () => import("/home/node/app/shop/pages/[...slug].vue")
  },
  {
    name: "activate_career_registration-hash___hu",
    path: "/activate_career_registration/:hash()",
    component: () => import("/home/node/app/shop/pages/activate_career_registration/[hash].vue")
  },
  {
    name: "activate_career_registration-hash___en",
    path: "/en/activate_career_registration/:hash()",
    component: () => import("/home/node/app/shop/pages/activate_career_registration/[hash].vue")
  },
  {
    name: "activate_registration-hash___hu",
    path: "/activate_registration/:hash()",
    component: () => import("/home/node/app/shop/pages/activate_registration/[hash].vue")
  },
  {
    name: "activate_registration-hash___en",
    path: "/en/activate_registration/:hash()",
    component: () => import("/home/node/app/shop/pages/activate_registration/[hash].vue")
  },
  {
    name: "admin-cms-content_preview-hash___hu",
    path: "/admin/cms/content_preview/:hash()",
    meta: _91hash_93gsAHaqMCmAMeta || {},
    component: () => import("/home/node/app/shop/pages/admin/cms/content_preview/[hash].vue")
  },
  {
    name: "admin-cms-content_preview-hash___en",
    path: "/en/admin/cms/content_preview/:hash()",
    meta: _91hash_93gsAHaqMCmAMeta || {},
    component: () => import("/home/node/app/shop/pages/admin/cms/content_preview/[hash].vue")
  },
  {
    name: "ajandekkartya-igenyles___hu",
    path: "/ajandekkartya-igenyles",
    meta: indexQNoSmgA0BdMeta || {},
    component: () => import("/home/node/app/shop/pages/ajandekkartya-igenyles/index.vue")
  },
  {
    name: "ajandekkartya-igenyles___en",
    path: "/en/ajandekkartya-igenyles",
    meta: indexQNoSmgA0BdMeta || {},
    component: () => import("/home/node/app/shop/pages/ajandekkartya-igenyles/index.vue")
  },
  {
    name: "bm-payment-return___hu",
    path: "/bm-payment-return",
    component: () => import("/home/node/app/shop/pages/bm-payment-return/index.vue")
  },
  {
    name: "bm-payment-return___en",
    path: "/en/bm-payment-return",
    component: () => import("/home/node/app/shop/pages/bm-payment-return/index.vue")
  },
  {
    name: "career_password_change-hash___hu",
    path: "/career_password_change/:hash()",
    component: () => import("/home/node/app/shop/pages/career_password_change/[hash].vue")
  },
  {
    name: "career_password_change-hash___en",
    path: "/en/career_password_change/:hash()",
    component: () => import("/home/node/app/shop/pages/career_password_change/[hash].vue")
  },
  {
    name: "catalog-slug___hu",
    path: "/catalog/:slug()",
    meta: _91slug_93stvohlG6D2Meta || {},
    component: () => import("/home/node/app/shop/pages/catalog/[slug].vue")
  },
  {
    name: "catalog-slug___en",
    path: "/en/catalog/:slug()",
    meta: _91slug_93stvohlG6D2Meta || {},
    component: () => import("/home/node/app/shop/pages/catalog/[slug].vue")
  },
  {
    name: "catalog___hu",
    path: "/catalog",
    meta: index1HztosNF15Meta || {},
    component: () => import("/home/node/app/shop/pages/catalog/index.vue")
  },
  {
    name: "catalog___en",
    path: "/en/catalog",
    meta: index1HztosNF15Meta || {},
    component: () => import("/home/node/app/shop/pages/catalog/index.vue")
  },
  {
    name: "cetelem-back-order_ident-status___hu",
    path: "/cetelem/back/:order_ident()/:status()",
    component: () => import("/home/node/app/shop/pages/cetelem/back/[order_ident]/[status].vue")
  },
  {
    name: "cetelem-back-order_ident-status___en",
    path: "/en/cetelem/back/:order_ident()/:status()",
    component: () => import("/home/node/app/shop/pages/cetelem/back/[order_ident]/[status].vue")
  },
  {
    name: "cetelem-back___hu",
    path: "/cetelem/back",
    component: () => import("/home/node/app/shop/pages/cetelem/back/index.vue")
  },
  {
    name: "cetelem-back___en",
    path: "/en/cetelem/back",
    component: () => import("/home/node/app/shop/pages/cetelem/back/index.vue")
  },
  {
    name: "content-id___hu",
    path: "/content/:id()",
    meta: _91id_93HSpFzXwdaaMeta || {},
    component: () => import("/home/node/app/shop/pages/content/[id].vue")
  },
  {
    name: "content-id___en",
    path: "/en/content/:id()",
    meta: _91id_93HSpFzXwdaaMeta || {},
    component: () => import("/home/node/app/shop/pages/content/[id].vue")
  },
  {
    name: "csr___hu",
    path: "/csr",
    meta: indexB6HveBuzRQMeta || {},
    component: () => import("/home/node/app/shop/pages/csr/index.vue")
  },
  {
    name: "csr___en",
    path: "/en/csr",
    meta: indexB6HveBuzRQMeta || {},
    component: () => import("/home/node/app/shop/pages/csr/index.vue")
  },
  {
    name: "faq___hu",
    path: "/faq",
    meta: indexi8wFU8pJ5hMeta || {},
    component: () => import("/home/node/app/shop/pages/faq/index.vue")
  },
  {
    name: "faq___en",
    path: "/en/faq",
    meta: indexi8wFU8pJ5hMeta || {},
    component: () => import("/home/node/app/shop/pages/faq/index.vue")
  },
  {
    name: "food-delivery-map___hu",
    path: "/food-delivery-map",
    component: () => import("/home/node/app/shop/pages/food-delivery-map/index.vue")
  },
  {
    name: "food-delivery-map___en",
    path: "/en/food-delivery-map",
    component: () => import("/home/node/app/shop/pages/food-delivery-map/index.vue")
  },
  {
    name: "forgotten-password___hu",
    path: "/forgotten-password",
    component: () => import("/home/node/app/shop/pages/forgotten-password/index.vue")
  },
  {
    name: "forgotten-password___en",
    path: "/en/forgotten-password",
    component: () => import("/home/node/app/shop/pages/forgotten-password/index.vue")
  },
  {
    name: "index___hu",
    path: "/",
    meta: indexxI9drhjhuDMeta || {},
    component: () => import("/home/node/app/shop/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexxI9drhjhuDMeta || {},
    component: () => import("/home/node/app/shop/pages/index.vue")
  },
  {
    name: "inspirations___hu",
    path: "/inspirations",
    meta: indexSC4GF1kSJuMeta || {},
    component: () => import("/home/node/app/shop/pages/inspirations/index.vue")
  },
  {
    name: "inspirations___en",
    path: "/en/inspirations",
    meta: indexSC4GF1kSJuMeta || {},
    component: () => import("/home/node/app/shop/pages/inspirations/index.vue")
  },
  {
    name: "karrier-ajanlatok-applicationGuid___hu",
    path: "/karrier/ajanlatok/:applicationGuid()",
    meta: _91applicationGuid_93UACRtUm4tqMeta || {},
    component: () => import("/home/node/app/shop/pages/karrier/ajanlatok/[applicationGuid].vue")
  },
  {
    name: "karrier-ajanlatok-applicationGuid___en",
    path: "/en/karrier/ajanlatok/:applicationGuid()",
    meta: _91applicationGuid_93UACRtUm4tqMeta || {},
    component: () => import("/home/node/app/shop/pages/karrier/ajanlatok/[applicationGuid].vue")
  },
  {
    name: "karrier-allas-slug.j-id-hash___hu",
    path: "/karrier/allas/:slug().j-:id()/:hash()",
    meta: _91hash_93Kvzfr3Zs15Meta || {},
    component: () => import("/home/node/app/shop/pages/karrier/allas/[slug].j-[id]/[hash].vue")
  },
  {
    name: "karrier-allas-slug.j-id-hash___en",
    path: "/en/karrier/allas/:slug().j-:id()/:hash()",
    meta: _91hash_93Kvzfr3Zs15Meta || {},
    component: () => import("/home/node/app/shop/pages/karrier/allas/[slug].j-[id]/[hash].vue")
  },
  {
    name: "karrier-allas-slug.j-id___hu",
    path: "/karrier/allas/:slug().j-:id()",
    meta: indexb3LInLQWhPMeta || {},
    component: () => import("/home/node/app/shop/pages/karrier/allas/[slug].j-[id]/index.vue")
  },
  {
    name: "karrier-allas-slug.j-id___en",
    path: "/en/karrier/allas/:slug().j-:id()",
    meta: indexb3LInLQWhPMeta || {},
    component: () => import("/home/node/app/shop/pages/karrier/allas/[slug].j-[id]/index.vue")
  },
  {
    name: "karrier-hirek___hu",
    path: "/karrier/hirek",
    meta: index0Vc2kInqmwMeta || {},
    component: () => import("/home/node/app/shop/pages/karrier/hirek/index.vue")
  },
  {
    name: "karrier-hirek___en",
    path: "/en/karrier/hirek",
    meta: index0Vc2kInqmwMeta || {},
    component: () => import("/home/node/app/shop/pages/karrier/hirek/index.vue")
  },
  {
    name: "login-Salesforce___hu",
    path: "/login/Salesforce",
    component: () => import("/home/node/app/shop/pages/login/Salesforce.vue")
  },
  {
    name: "login-Salesforce___en",
    path: "/en/login/Salesforce",
    component: () => import("/home/node/app/shop/pages/login/Salesforce.vue")
  },
  {
    name: "loyalty-program-faq___hu",
    path: "/loyalty-program/faq",
    meta: index0nkIp9U28UMeta || {},
    component: () => import("/home/node/app/shop/pages/loyalty-program/faq/index.vue")
  },
  {
    name: "loyalty-program-faq___en",
    path: "/en/loyalty-program/faq",
    meta: index0nkIp9U28UMeta || {},
    component: () => import("/home/node/app/shop/pages/loyalty-program/faq/index.vue")
  },
  {
    name: "news-type-slug___hu",
    path: "/news/:type()/:slug()",
    meta: _91slug_93mtGs7l9wl3Meta || {},
    component: () => import("/home/node/app/shop/pages/news/[type]/[slug].vue")
  },
  {
    name: "news-type-slug___en",
    path: "/en/news/:type()/:slug()",
    meta: _91slug_93mtGs7l9wl3Meta || {},
    component: () => import("/home/node/app/shop/pages/news/[type]/[slug].vue")
  },
  {
    name: "news___hu",
    path: "/news",
    meta: index1l1eHyVrkYMeta || {},
    component: () => import("/home/node/app/shop/pages/news/index.vue")
  },
  {
    name: "news___en",
    path: "/en/news",
    meta: index1l1eHyVrkYMeta || {},
    component: () => import("/home/node/app/shop/pages/news/index.vue")
  },
  {
    name: "otp-back___hu",
    path: "/otp/back",
    component: () => import("/home/node/app/shop/pages/otp/back/index.vue")
  },
  {
    name: "otp-back___en",
    path: "/en/otp/back",
    component: () => import("/home/node/app/shop/pages/otp/back/index.vue")
  },
  {
    name: "password_change-hash___hu",
    path: "/password_change/:hash()",
    component: () => import("/home/node/app/shop/pages/password_change/[hash].vue")
  },
  {
    name: "password_change-hash___en",
    path: "/en/password_change/:hash()",
    component: () => import("/home/node/app/shop/pages/password_change/[hash].vue")
  },
  {
    name: "payment-redirect___hu",
    path: "/payment-redirect",
    component: () => import("/home/node/app/shop/pages/payment-redirect/index.vue")
  },
  {
    name: "payment-redirect___en",
    path: "/en/payment-redirect",
    component: () => import("/home/node/app/shop/pages/payment-redirect/index.vue")
  },
  {
    name: "petrol-slug___hu",
    path: "/petrol/:slug()",
    meta: _91slug_93P7osP2mq8YMeta || {},
    component: () => import("/home/node/app/shop/pages/petrol/[slug].vue")
  },
  {
    name: "petrol-slug___en",
    path: "/en/petrol/:slug()",
    meta: _91slug_93P7osP2mq8YMeta || {},
    component: () => import("/home/node/app/shop/pages/petrol/[slug].vue")
  },
  {
    name: "petrol-faq___hu",
    path: "/petrol/faq",
    meta: indexFEH3w2yZ6FMeta || {},
    component: () => import("/home/node/app/shop/pages/petrol/faq/index.vue")
  },
  {
    name: "petrol-faq___en",
    path: "/en/petrol/faq",
    meta: indexFEH3w2yZ6FMeta || {},
    component: () => import("/home/node/app/shop/pages/petrol/faq/index.vue")
  },
  {
    name: "petrol___hu",
    path: "/petrol",
    meta: indexqHI4RhCB24Meta || {},
    component: () => import("/home/node/app/shop/pages/petrol/index.vue")
  },
  {
    name: "petrol___en",
    path: "/en/petrol",
    meta: indexqHI4RhCB24Meta || {},
    component: () => import("/home/node/app/shop/pages/petrol/index.vue")
  },
  {
    name: "press___hu",
    path: "/press",
    meta: indexwECjOhRjxBMeta || {},
    component: () => import("/home/node/app/shop/pages/press/index.vue")
  },
  {
    name: "press___en",
    path: "/en/press",
    meta: indexwECjOhRjxBMeta || {},
    component: () => import("/home/node/app/shop/pages/press/index.vue")
  },
  {
    name: "prize-game___hu",
    path: "/prize-game",
    meta: indexaZXwqL9skMMeta || {},
    component: () => import("/home/node/app/shop/pages/prize-game/index.vue")
  },
  {
    name: "prize-game___en",
    path: "/en/prize-game",
    meta: indexaZXwqL9skMMeta || {},
    component: () => import("/home/node/app/shop/pages/prize-game/index.vue")
  },
  {
    name: "product-list-id___hu",
    path: "/product-list/:id()",
    component: () => import("/home/node/app/shop/pages/product-list/[id].vue")
  },
  {
    name: "product-list-id___en",
    path: "/en/product-list/:id()",
    component: () => import("/home/node/app/shop/pages/product-list/[id].vue")
  },
  {
    name: "product-id___hu",
    path: "/product/:id()",
    component: () => import("/home/node/app/shop/pages/product/[id].vue")
  },
  {
    name: "product-id___en",
    path: "/en/product/:id()",
    component: () => import("/home/node/app/shop/pages/product/[id].vue")
  },
  {
    name: "shop-basket___hu",
    path: "/shop/basket",
    meta: indexN8hjkpKSOVMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/basket/index.vue")
  },
  {
    name: "shop-basket___en",
    path: "/en/shop/basket",
    meta: indexN8hjkpKSOVMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/basket/index.vue")
  },
  {
    name: "shop-checkout-success-orderIdent___hu",
    path: "/shop/checkout-success/:orderIdent()",
    meta: _91orderIdent_93zBL4WFDr1UMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/checkout-success/[orderIdent].vue")
  },
  {
    name: "shop-checkout-success-orderIdent___en",
    path: "/en/shop/checkout-success/:orderIdent()",
    meta: _91orderIdent_93zBL4WFDr1UMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/checkout-success/[orderIdent].vue")
  },
  {
    name: "shop-checkout-type___hu",
    path: "/shop/checkout/:type()",
    meta: _91type_932cM847pHysMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/checkout/[type].vue")
  },
  {
    name: "shop-checkout-type___en",
    path: "/en/shop/checkout/:type()",
    meta: _91type_932cM847pHysMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/checkout/[type].vue")
  },
  {
    name: "shop-compare___hu",
    path: "/shop/compare",
    component: () => import("/home/node/app/shop/pages/shop/compare/index.vue")
  },
  {
    name: "shop-compare___en",
    path: "/en/shop/compare",
    component: () => import("/home/node/app/shop/pages/shop/compare/index.vue")
  },
  {
    name: "shop___hu",
    path: "/shop",
    meta: indexKnSZWeQjOIMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/index.vue")
  },
  {
    name: "shop___en",
    path: "/en/shop",
    meta: indexKnSZWeQjOIMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/index.vue")
  },
  {
    name: "shop-list-list_name___hu",
    path: "/shop/list/:list_name()",
    meta: _91list_name_93uif8j5KMxUMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/list/[list_name].vue")
  },
  {
    name: "shop-list-list_name___en",
    path: "/en/shop/list/:list_name()",
    meta: _91list_name_93uif8j5KMxUMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/list/[list_name].vue")
  },
  {
    name: "shop-loyalty-offers-list_name___hu",
    path: "/shop/loyalty-offers/:list_name()",
    meta: _91list_name_93xPFJgISEL6Meta || {},
    component: () => import("/home/node/app/shop/pages/shop/loyalty-offers/[list_name].vue")
  },
  {
    name: "shop-loyalty-offers-list_name___en",
    path: "/en/shop/loyalty-offers/:list_name()",
    meta: _91list_name_93xPFJgISEL6Meta || {},
    component: () => import("/home/node/app/shop/pages/shop/loyalty-offers/[list_name].vue")
  },
  {
    name: "shop-profile-billing-addresses___hu",
    path: "/shop/profile/billing-addresses",
    meta: indexlQOhyuvAS5Meta || {},
    component: () => import("/home/node/app/shop/pages/shop/profile/billing-addresses/index.vue")
  },
  {
    name: "shop-profile-billing-addresses___en",
    path: "/en/shop/profile/billing-addresses",
    meta: indexlQOhyuvAS5Meta || {},
    component: () => import("/home/node/app/shop/pages/shop/profile/billing-addresses/index.vue")
  },
  {
    name: "shop-profile-data___hu",
    path: "/shop/profile/data",
    meta: index7ylE7OhQj1Meta || {},
    component: () => import("/home/node/app/shop/pages/shop/profile/data/index.vue")
  },
  {
    name: "shop-profile-data___en",
    path: "/en/shop/profile/data",
    meta: index7ylE7OhQj1Meta || {},
    component: () => import("/home/node/app/shop/pages/shop/profile/data/index.vue")
  },
  {
    name: "shop-profile-delivery-addresses___hu",
    path: "/shop/profile/delivery-addresses",
    meta: index4NLRw7nPzCMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/profile/delivery-addresses/index.vue")
  },
  {
    name: "shop-profile-delivery-addresses___en",
    path: "/en/shop/profile/delivery-addresses",
    meta: index4NLRw7nPzCMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/profile/delivery-addresses/index.vue")
  },
  {
    name: "shop-profile-loyalty-card-coupons___hu",
    path: "/shop/profile/loyalty-card/coupons",
    meta: couponsJTHtAW6WxaMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/profile/loyalty-card/coupons.vue")
  },
  {
    name: "shop-profile-loyalty-card-coupons___en",
    path: "/en/shop/profile/loyalty-card/coupons",
    meta: couponsJTHtAW6WxaMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/profile/loyalty-card/coupons.vue")
  },
  {
    name: "shop-profile-loyalty-card___hu",
    path: "/shop/profile/loyalty-card",
    meta: indexDH7sHo27W4Meta || {},
    component: () => import("/home/node/app/shop/pages/shop/profile/loyalty-card/index.vue")
  },
  {
    name: "shop-profile-loyalty-card___en",
    path: "/en/shop/profile/loyalty-card",
    meta: indexDH7sHo27W4Meta || {},
    component: () => import("/home/node/app/shop/pages/shop/profile/loyalty-card/index.vue")
  },
  {
    name: "shop-profile-loyalty-card-partner-program___hu",
    path: "/shop/profile/loyalty-card/partner-program",
    meta: partner_45programRfdRBFCgxuMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/profile/loyalty-card/partner-program.vue")
  },
  {
    name: "shop-profile-loyalty-card-partner-program___en",
    path: "/en/shop/profile/loyalty-card/partner-program",
    meta: partner_45programRfdRBFCgxuMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/profile/loyalty-card/partner-program.vue")
  },
  {
    name: "shop-profile-loyalty-card-stickers-id___hu",
    path: "/shop/profile/loyalty-card/stickers/:id()",
    meta: _91id_93RZPRUIfXksMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/profile/loyalty-card/stickers/[id].vue")
  },
  {
    name: "shop-profile-loyalty-card-stickers-id___en",
    path: "/en/shop/profile/loyalty-card/stickers/:id()",
    meta: _91id_93RZPRUIfXksMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/profile/loyalty-card/stickers/[id].vue")
  },
  {
    name: "shop-profile-loyalty-card-stickers___hu",
    path: "/shop/profile/loyalty-card/stickers",
    meta: indexfFtOpww9USMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/profile/loyalty-card/stickers/index.vue")
  },
  {
    name: "shop-profile-loyalty-card-stickers___en",
    path: "/en/shop/profile/loyalty-card/stickers",
    meta: indexfFtOpww9USMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/profile/loyalty-card/stickers/index.vue")
  },
  {
    name: "shop-profile-loyalty-card-transactions___hu",
    path: "/shop/profile/loyalty-card/transactions",
    meta: transactionsxSRjEBp4kYMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/profile/loyalty-card/transactions.vue")
  },
  {
    name: "shop-profile-loyalty-card-transactions___en",
    path: "/en/shop/profile/loyalty-card/transactions",
    meta: transactionsxSRjEBp4kYMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/profile/loyalty-card/transactions.vue")
  },
  {
    name: "shop-profile-loyalty-program___hu",
    path: "/shop/profile/loyalty-program",
    meta: indexeVkScb6RCWMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/profile/loyalty-program/index.vue")
  },
  {
    name: "shop-profile-loyalty-program___en",
    path: "/en/shop/profile/loyalty-program",
    meta: indexeVkScb6RCWMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/profile/loyalty-program/index.vue")
  },
  {
    name: "shop-profile-mailing-addresses___hu",
    path: "/shop/profile/mailing-addresses",
    meta: index7ysS7fJFJeMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/profile/mailing-addresses/index.vue")
  },
  {
    name: "shop-profile-mailing-addresses___en",
    path: "/en/shop/profile/mailing-addresses",
    meta: index7ysS7fJFJeMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/profile/mailing-addresses/index.vue")
  },
  {
    name: "shop-profile-manage___hu",
    path: "/shop/profile/manage",
    meta: indexbXQEJQhltJMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/profile/manage/index.vue")
  },
  {
    name: "shop-profile-manage___en",
    path: "/en/shop/profile/manage",
    meta: indexbXQEJQhltJMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/profile/manage/index.vue")
  },
  {
    name: "shop-profile-order-again___hu",
    path: "/shop/profile/order-again",
    meta: indexujAj74ulLWMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/profile/order-again/index.vue")
  },
  {
    name: "shop-profile-order-again___en",
    path: "/en/shop/profile/order-again",
    meta: indexujAj74ulLWMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/profile/order-again/index.vue")
  },
  {
    name: "shop-profile-orders___hu",
    path: "/shop/profile/orders",
    meta: indexlcrmltyF7XMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/profile/orders/index.vue")
  },
  {
    name: "shop-profile-orders___en",
    path: "/en/shop/profile/orders",
    meta: indexlcrmltyF7XMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/profile/orders/index.vue")
  },
  {
    name: "shop-profile-saved-baskets___hu",
    path: "/shop/profile/saved-baskets",
    meta: indexGK17q6kRkeMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/profile/saved-baskets/index.vue")
  },
  {
    name: "shop-profile-saved-baskets___en",
    path: "/en/shop/profile/saved-baskets",
    meta: indexGK17q6kRkeMeta || {},
    component: () => import("/home/node/app/shop/pages/shop/profile/saved-baskets/index.vue")
  },
  {
    name: "simple-back___hu",
    path: "/simple/back",
    component: () => import("/home/node/app/shop/pages/simple/back/index.vue")
  },
  {
    name: "simple-back___en",
    path: "/en/simple/back",
    component: () => import("/home/node/app/shop/pages/simple/back/index.vue")
  },
  {
    name: "stores-slug___hu",
    path: "/stores/:slug()",
    meta: _91slug_934MzHKpJRObMeta || {},
    component: () => import("/home/node/app/shop/pages/stores/[slug].vue")
  },
  {
    name: "stores-slug___en",
    path: "/en/stores/:slug()",
    meta: _91slug_934MzHKpJRObMeta || {},
    component: () => import("/home/node/app/shop/pages/stores/[slug].vue")
  },
  {
    name: "stores___hu",
    path: "/stores",
    meta: indexnOnj926mtMMeta || {},
    component: () => import("/home/node/app/shop/pages/stores/index.vue")
  },
  {
    name: "stores___en",
    path: "/en/stores",
    meta: indexnOnj926mtMMeta || {},
    component: () => import("/home/node/app/shop/pages/stores/index.vue")
  },
  {
    name: "test-recon___hu",
    path: "/test/recon",
    component: () => import("/home/node/app/shop/pages/test/recon/index.vue")
  },
  {
    name: "test-recon___en",
    path: "/en/test/recon",
    component: () => import("/home/node/app/shop/pages/test/recon/index.vue")
  },
  {
    name: "unsubscribe___hu",
    path: "/unsubscribe",
    component: () => import("/home/node/app/shop/pages/unsubscribe/index.vue")
  },
  {
    name: "unsubscribe___en",
    path: "/en/unsubscribe",
    component: () => import("/home/node/app/shop/pages/unsubscribe/index.vue")
  },
  {
    name: "user_email_update-hash___hu",
    path: "/user_email_update/:hash()",
    component: () => import("/home/node/app/shop/pages/user_email_update/[hash].vue")
  },
  {
    name: "user_email_update-hash___en",
    path: "/en/user_email_update/:hash()",
    component: () => import("/home/node/app/shop/pages/user_email_update/[hash].vue")
  },
  {
    name: component_45stubES7zRCavDcMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubES7zRCavDc
  }
]